import { useGetWhoamiQuery } from "Services";
import { OrgRole } from "Types";

type OrganizationInfo = {
  id: string;
  name: string;
  role: OrgRole;
};

const useCurrentOrganization = (): OrganizationInfo | null => {
  const { data } = useGetWhoamiQuery();

  return data
    ? {
        name: data.organization_name,
        id: data.organization_id,
        role: data.org_role,
      }
    : null;
};

export default useCurrentOrganization;
